export default __webpack_public_path__ + "static/media/No_Search_illustration.cefe31ec.svg";